<div *ngIf="isadmin" class="form-group row">
  <div class="col-md-12" style="white-space:nowrap">
    <button id="btnPublish" style="margin-left:0.5%;background-color:#6cd4a8;color:BLACK;FONT-WEIGHT:500;" type="submit"
      class="btn btn-grad" tabindex="0" title="Publish Project" (click)="Publishdata();" aria-label="Publish Project"
      title="Publish Project">Publish Project</button>

    <button id="btnUnPublish" type="submit"
      style="margin-left:0.5%;background-color:#efe9f2;color:BLACK;FONT-WEIGHT:500;" class="btn btn-grad" tabindex="0"
      title="UnPublish Project" (click)="UnPublishdata();" aria-label="UnPublish Project">UnPublish Project
    </button>
  </div>
</div>
<div class="">
  <div class="row ml-0 mr-0 pt-1 pl-1 mobiletext w-100 desktop-pl" [formGroup]="formControl">
    <div class="mat-column-IdInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
    </div>
    <div [ngClass]="isadmin?'mat-column-FiscalYearInput':'mat-column-FiscalYearInputE'"
      class="mat-column-FiscalYearInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-label="FiscalYear" placeholder="Fiscal Year" [(ngModel)]="FiscalYear" title="FiscalYear"
          formControlName="FiscalYear">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Fiscal Year" title="FiscalYear"
          style=" height: 32px !important;" [(ngModel)]="FiscalYear" aria-label="Search For Fiscal Year"
          formControlName="FiscalYear">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectNumInput':'mat-column-ProjectNumInputE'"
      class="mat-column-ProjectNumInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectNumber" placeholder="Project #" [(ngModel)]="ProjectNumber" title="Project Number"
          formControlName="ProjectNumber">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project #"
          title="Project Number" style=" height: 32px !important;" [(ngModel)]="ProjectNumber"
          aria-labelledby="Project Number" formControlName="ProjectNumber">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectNameInput':'mat-column-ProjectNameInputE'"
      class="mat-column-ProjectNameInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectName" placeholder="Project Name" [(ngModel)]="ProjectName" title="Project Name"
          formControlName="ProjectName">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Name"
          title="Project Name" style=" height: 32px !important;" [(ngModel)]="ProjectName"
          aria-labelledby="Project Name" formControlName="ProjectName">
      </div>
    </div>

    <!-- <div [ngClass]="isadmin?'mat-column-ProjectCategoryInput':'mat-column-ProjectCategoryInputE'"
      class="mat-column-ProjectCategoryInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectCategory" placeholder="Project Category" [(ngModel)]="ProjectCategory"
          title="Project Category" formControlName="ProjectCategory">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Category"
          title="Project Category" style=" height: 32px !important;" [(ngModel)]="ProjectCategory"
          aria-labelledby="ProjectCategory" formControlName="ProjectCategory">
      </div>
    </div> -->

    <div [ngClass]="isadmin?'mat-column-ProjectSubCategoryInput':'mat-column-ProjectSubCategoryInputE'"
      class="mat-column-ProjectSubCategoryInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectSubcategory" placeholder="Project Category" [(ngModel)]="ProjectSubCategory"
          title="Project Category" formControlName="ProjectSubCategory">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Category"
          title="Project Category" style=" height: 32px !important;" [(ngModel)]="ProjectSubCategory"
          aria-labelledby="Project Category" formControlName="ProjectSubCategory">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectStatus':'mat-column-ProjectStatusE'"
      class="mat-column-ProjectStatusInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectStatus" placeholder="Project Status" [(ngModel)]="ProjectStatus" title="ProjectStatus"
          formControlName="ProjectStatus">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Status"
          title="Project Status" style=" height: 32px !important;" [(ngModel)]="ProjectStatus"
          aria-labelledby="ProjectStatus" formControlName="ProjectStatus">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-CIPBudgetAmountInput':'mat-column-CIPBudgetAmountInputE'"
      class="mat-column-CIPBudgetAmountInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="Project Budget Amount" placeholder="Project Budget Amount" [(ngModel)]="CIPBudgetAmount"
          title="CIP Budget Amount" formControlName="CIPBudgetAmount">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="Project Budget Amount" [(ngModel)]="CIPBudgetAmount" title="Project Budget Amount"
          aria-labelledby="Project Budget Amount" formControlName="CIPBudgetAmount">
      </div>
    </div>

    <!-- <div *ngIf="isadmin" class="mat-column-ActualsInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="Actuals" placeholder="Actuals" [(ngModel)]="Actuals" title="Actuals"
          formControlName="Actuals">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="Actuals" [(ngModel)]="Actuals" title="Actuals" aria-labelledby="Actuals"
          formControlName="Actuals">
      </div>
    </div> -->

    <!-- <div *ngIf="isadmin" [ngClass]="isadmin?'mat-column-AmountEncumberedInput':'mat-column-AmountEncumberedInputE'"
      class="mat-column-AmountEncumberedInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="Amount Encumbered" placeholder="Amount Encumbered" [(ngModel)]="AmountEncumbered"
          title="Amount Encumbered" formControlName="AmountEncumbered">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="" [(ngModel)]="AmountEncumbered" title="Amount Encumbered" aria-labelledby="Amount Encumbered"
          formControlName="AmountEncumbered">
      </div>
    </div> -->

    <!-- <div *ngIf="isadmin" [ngClass]="isadmin?'mat-column-RemainingBalanceInput':'mat-column-RemainingBalanceInputE'"
      class="mat-column-RemainingBalanceInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="Remaining Balance" placeholder="Remaining Balance" [(ngModel)]="RemainingBalance"
          title="Remaining Balance" formControlName="RemainingBalance">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="" [(ngModel)]="RemainingBalance" title="Remaining Balance" aria-labelledby="Remaining Balance"
          formControlName="RemainingBalance">
      </div>
    </div> -->

    <div *ngIf="isadmin" class="mat-column-PublishedInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="PublishedProject" placeholder="Published" [(ngModel)]="PublishedProject"
          title="PublishedProject" formControlName="PublishedProject">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="Published" [(ngModel)]="PublishedProject" title="PublishedProject"
          aria-labelledby="PublishedProject" formControlName="PublishedProject">
      </div>
    </div>
  </div>
  &nbsp;

  <div class="ml-1 mr-1 mb-0 mat-elevation-z8">
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container *ngIf="isadmin" matColumnDef="Select">
        <mat-header-cell *matHeaderCellDef tabindex=0>
          <input type="checkbox" (change)="$event ? masterToggle() : null" aria-label="Select"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-header-cell>
        <mat-cell *matCellDef="let row" tabindex="0" style="width: 23px; background-color: rgb(134, 158, 172);">
          <input type="checkbox" (click)="$event.stopPropagation()" aria-label="Select"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="FiscalYear">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-FiscalYear':'mat-column-FiscalYearE'" aria-label="Fiscal Year">
          <label id="FiscalYear" aria-label="FiscalYear">Fiscal Year</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-FiscalYear':'mat-column-FiscalYearE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Fiscal Year">Fiscal
              Year:</label></span>
          <div class="displaynormal column-overflow" title="{{element.FiscalYear}} ">{{element.FiscalYear}}
          </div>
          <div class="displaysmall" style="display: none;" title="{{element.FiscalYear}} ">{{element.FiscalYear}}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ProjectNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectNumber':'mat-column-ProjectNumberE'" aria-label="Project Number">
          <label id="ProjectNumber" aria-label="Project Number">Project #</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectNumber':'mat-column-ProjectNumberE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Number">
              Project #:</label></span>
          <div class="displaynormal column-overflow" title="{{element.ProjectNumber}} ">
            {{element.ProjectNumber?element.ProjectNumber:'TBD'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.ProjectNumber}} ">
            {{element.ProjectNumber?element.ProjectNumber:'TBD'}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ProjectName">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectName':'mat-column-ProjectNameE'" aria-label="Project Name">
          <label id="ProjectName" aria-label="Project Name">Project Name</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectName':'mat-column-ProjectNameE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Name">
              Project Name:</label></span>
          <div class="displaynormal column-overflow" title="{{element.ProjectName}} ">
            {{element.ProjectName}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.ProjectName}} ">
            {{element.ProjectName}}</div>
        </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="ProjectCategory">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectCategory':'mat-column-ProjectCategoryE'" aria-label="Project Category">
          <label id="Project Category" aria-label="Project Category">Project Category</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectCategory':'mat-column-ProjectCategoryE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Category">
              Project Category:</label></span>
          <div class="displaynormal column-overflow" title="{{element.ProjectCategory}} ">
            {{element.ProjectCategory}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.ProjectCategory}} ">
            {{element.ProjectCategory}}</div>

        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="ProjectSubCategory">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectSubCategory':'mat-column-ProjectSubCategoryE'"
          aria-label="Project SubCategory">
          <label id="ProjectSubCategory" aria-label="Project Category">Project Category</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectSubCategory':'mat-column-ProjectSubCategoryE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Category">
              Project Category:</label></span>
          <div class="displaynormal column-overflow" title="{{element.ProjectSubCategory}} ">
            {{element.ProjectSubCategory}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.ProjectSubCategory}} ">
            {{element.ProjectSubCategory}}</div>

        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="ProjectStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectStatus':'mat-column-ProjectStatusE'" aria-label="Project Status">
          <label id="ProjectStatus" aria-label="Project Status">Project Status</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectStatus':'mat-column-ProjectStatusE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Status">
              Project Status:</label></span>
          <div class="displaynormal column-overflow" title="{{element.ProjectStatus}} ">
            {{element.ProjectStatus}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.ProjectStatus}} ">
            {{element.ProjectStatus}}</div>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="CIPBudgetAmount">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-CIPBudgetAmount':'mat-column-CIPBudgetAmountE'"
          aria-label="Project Budget Amount">
          <label id="CIPBudgetAmount" aria-label="CIP BudgetAmount">Project Budget Amount</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-CIPBudgetAmount':'mat-column-CIPBudgetAmountE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Project Budget Amount">
              Project Budget Amount:</label></span>
          <div class="displaynormal column-overflow" style="margin-left: 38%;" title="{{element.CIPBudgetAmount}} ">
            ${{element.CIPBudgetAmount  | number : '1.2-2'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.CIPBudgetAmount}} ">
            ${{element.CIPBudgetAmount  | number : '1.2-2'}}</div>

        </mat-cell>
      </ng-container>

      <!-- <ng-container *ngIf="isadmin" matColumnDef="Actuals">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-Actuals':'mat-column-ActualsE'" aria-label="Actuals">
          <label id="Actuals" aria-label="Actuals">Actuals</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0" [ngClass]="isadmin?'mat-column-Actuals':'mat-column-ActualsE'"
          style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Actuals">
              Actuals:</label></span>
          <div class="displaynormal column-overflow" title="{{element.Actuals}} ">
            ${{element.Actuals  | number : '1.2-2'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.Actuals}} ">
            ${{element.Actuals  | number : '1.2-2'}}</div>

        </mat-cell>
      </ng-container> -->

      <!-- <ng-container *ngIf="isadmin" matColumnDef="AmountEncumbered">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-AmountEncumbered':'mat-column-AmountEncumberedE'"
          aria-label="Amount Encumbered">
          <label id="AmountEncumbered" aria-label="Amount Encumbered">Amount Encumbered</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-AmountEncumbered':'mat-column-AmountEncumberedE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Amount Encumbered">
              Amount Encumbered:</label></span>
          <div class="displaynormal column-overflow" title="{{element.AmountEncumbered}} ">
            ${{element.AmountEncumbered  | number : '1.2-2'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.AmountEncumbered}} ">
            ${{element.AmountEncumbered  | number : '1.2-2'}}</div>

        </mat-cell>
      </ng-container> -->

      <!-- <ng-container *ngIf="isadmin" matColumnDef="RemainingBalance">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-RemainingBalance':'mat-column-RemainingBalanceE'"
          aria-label="Remaining Balance">
          <label id="Remaining Balance" aria-label="Remaining Balance">Remaining Balance</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-RemainingBalance':'mat-column-RemainingBalanceE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Remaining Balance">
              Remaining Balance:</label></span>
          <div class="displaynormal column-overflow" title="{{element.RemainingBalance}} ">
            ${{element.RemainingBalance | number : '1.2-2'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.RemainingBalance}} ">
            ${{element.RemainingBalance | number : '1.2-2'}}</div>

        </mat-cell>
      </ng-container> -->

      <ng-container *ngIf="isadmin" matColumnDef="Published">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Published">
          <label id="Published" aria-label="Published">Published</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="element.PublishedProject === true ?'mat-cell-pcolor':''" style="width: 100%; ">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Published">Published:
            </label></span>
          <div class="displaynormal column-overflow" title="{{element.PublishedProject === true ? 'Yes' : 'No'}}">
            {{element.PublishedProject === true ? 'Yes' : 'No'}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.PublishedProject === true ? 'Yes' : 'No'}}">
            {{element.PublishedProject === true ? 'Yes' : 'No'}}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="View">
        <mat-header-cell *matHeaderCellDef> View</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">View:</span>
          <img style="cursor: pointer; color: #fff;" title="View" (click)="ViewProjectDocsinfo(element)" tabindex="0"
            src="../assets/images/icon_viewnewadam.png">
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="isadmin" matColumnDef="Update">
        <mat-header-cell *matHeaderCellDef> Update</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Update:</span>
          <img style="cursor: pointer; color: #fff;" title="Update" (click)="updateprojectinfo(element)" tabindex="0"
            src="../assets/images/icon_edit.png">
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="isadmin" matColumnDef="Delete">
        <mat-header-cell *matHeaderCellDef> Delete</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Delete:</span>
          <img style="cursor: pointer; color: #fff;" title="Delete" (click)="DeleteProjectInfo(element);" tabindex="0"
            src="../assets/images/delete_icon.png">
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[10,15,50,100]" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>
  <div class="form-group row">
    <div class="col-md-12" style="color:crimson; text-align:center;" tabindex="0">
      <br>
      {{projectmessage}}
    </div>
  </div>
</div>
